/**
 * Общие для всех страниц скрипты
 */
import("./main");

/**
 * Загрузка раскрывающихся меню в сайдбаре
 */
import("./components/schoolSideLoader").then((_) => {});

/**
 * Добавление возможности просмотра всех стран на странице Статей
 */
$(document).on("click", ".chosen-country__all", function (e) {
    $(this).hide();
    $(this).parent().find(".chosen-country__scroll").addClass("scroll");
});

/**
 * Модальное окно с картинками отзывов
 */
import("../../../src/js/reviews").then((_) => {});

window.onload = () => {
    // Базовые настройки IntersectionObserver
    const options = {
        // Родитель целевого элемента
        root: null,
        // Отступ
        rootMargin: "0px",
        // Процент пересечения целевого элемента
        threshold: 0.1,
    };

    // Определяем наблюдателя
    const observer = new IntersectionObserver((entries, observer) => {
        // Для каждого входимого элемента
        entries.forEach((entry) => {
            // Если элемент появился на экране в зоне видимости
            if (entry.isIntersecting) {
                const classList = entry.target.classList;

                // Для комментариев
                if (classList.contains("review")) {
                    import("./components/newComments");
                }
            }
        });
    }, options);

    // Определяем наблюдаемые элементы
    const observedItems = document.querySelectorAll(".review");

    // К каждому наблюдаемому элементу
    observedItems.forEach((form) => {
        // подключаем IntersectionObserver
        observer.observe(form);
    });
};
